import React, { useEffect, useState } from "react";

import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import { toast } from "react-toastify";
import axios from "../../../../node_modules/axios/index";
import LoaderButton from "../../Common/LoaderButton";
import Loader from "../../Common/Loader";
import { Modal, Button, Table, Dropdown, Form } from "react-bootstrap";
import NoDataFound from "../../Common/NoDataFound";
import "react-toastify/dist/ReactToastify.css";
import Alert from "../../Common/Alert";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { handleApiError } from "../../../helpers/errorResponseHelper";
import {
  logOut,
  setInValidUser,
} from "../../../redux/actions/authActions/authAction";
import constatntMessages from "../../../constants/constatntMessages";
import { fetchIpAddress } from "../../../helpers/commonHelpers";
import BackButton from "../../Common/Backbutton";
import SmallLoaderButton from "../../Common/SmallLoaderButton";
const Department = () => {
  //Create Department

  const accessToken = localStorage.getItem("accessToken");
  const [formValues, setFormValues] = useState({ name: "" });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isEditLoading, setIsEditLoading] = useState(false);

  //List Department
  const [departments, setDepartments] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [searchKey, setSearchKey] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [order, setOrder] = useState(-1);
  const [isFetching, setIsFetching] = useState(false);
  //EDIT DEPARTMENT
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [departmentName, setDepartmentName] = useState("");
  const [editformValues, setEditFormValues] = useState({
    name: "",
  });
  const [isConfirming, setIsConfirming] = useState(false);
  //DELETE DEPARTMENT
  const navigate = useNavigate();
  const location = useLocation();
  // const navigate = useNavigate();

  const [camefromPreviousPage, setCamefrompreviospage] = useState(
    location.state?.camefromPreviousPage || false
  );

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [departmentToDelete, setDepartmenToDelete] = useState(null);
  const employeeData = useSelector((state) => state.user);
  const [searchError, setSearchError] = useState("");

  const [screenSize, setScreenSize] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (employeeData?.userData) {
      if (employeeData.userData.isAdmin === false) {
        navigate("/page-not-found");
      }
    }
  }, [employeeData?.userData]);
  useEffect(() => {
    document.title = "Department: MinutesVault";
    if (!accessToken) {
      navigate("/login");
    }
    fetchDepartmentData();
  }, [searchKey, page, limit, order]);

  const userData = JSON.parse(localStorage.getItem("userData"));
  const authData = useSelector((state) => state.auth);
  const excludeHtml = /^[0-9a-zA-Z .,:\n;%@&#!$^*+=`~()/_'"\\\-?|{}\[\]]+$/;
  const dispatch = useDispatch();
  if (authData.isInValidUser && authData.isInvalidUserChecked) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("rememberMe");
    dispatch(logOut());
    navigate("/login");
  }
  const organizationId = userData?.organizationId;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleEditClick = (department) => {
    setIsConfirming(false);
    setSelectedDepartment(department);
    setDepartmentName(department.name);
    setShowEditModal(true);
    setErrors(false);
  };

  const isValidate = () => {
    let isValid = true;
    const errors = {};

    if (!formValues.name.trim()) {
      errors.name = "Department is required";
      isValid = false;
    } else if (!excludeHtml.test(formValues.name)) {
      errors.name = constatntMessages.invalidInput;
      isValid = false;
    } else if (
      formValues.name.trim().length < 2 ||
      formValues.name.trim().length > 100
    ) {
      errors.name = "Department must be between 2 - 100 characters";
      isValid = false;
    }

    setErrors(errors);

    return isValid;
  };

  const dpnameValidationCheck = () => {
    const newErrors = { ...errors };

    if (!formValues.name.trim()) {
      newErrors.name = "Department is required";
    } else if (!excludeHtml.test(formValues.name)) {
      newErrors.name = constatntMessages.invalidInput;
    } else if (
      formValues.name.trim().length < 2 ||
      formValues.name.trim().length > 100
    ) {
      newErrors.name = "Department must be between 2 - 100  characters";
    }
    setErrors(newErrors);
    return newErrors;
  };

  //CREATE DEPRATMENT
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const trimmedFormValues = {
      ...formValues,
      name: formValues.name.trim(),
    };

    if (isValidate()) {
      try {
        if (!accessToken) {
          console.warn("Access token is missing");
          return;
        }
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/V1/department/createDepartment`,
          { ...trimmedFormValues, organizationId },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: accessToken,
              ip: await fetchIpAddress(),
            },
          }
        );
        if (response?.data?.data?.isInValidUser) {
          toast.error(response?.data?.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          dispatch(setInValidUser(true));
        } else {
          dispatch(setInValidUser(false));
        }
        if (response.data.success) {
          setFormValues({ name: "" });
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          fetchDepartmentData();
        } else {
          toast.error(response.data.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      } catch (error) {
        if (handleApiError(error)) return;

        console.log(
          "Error while creating department",
          error.response?.data?.message || error.message
        );
      } finally {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
    }
  };

  //LIST DEPARTMENT
  const fetchDepartment = async (bodyData) => {
    if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }
    try {
      setIsFetching(true);
      const headerObject = {
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
        params: { limit, page, order },
      };
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/V1/department/listDepartment`,
        bodyData,
        headerObject
      );
      if (response?.data?.data?.isInValidUser) {
        toast.error(response?.data?.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        dispatch(setInValidUser(true));
      } else {
        dispatch(setInValidUser(false));
      }
      const data = response.data.data || {};

      setDepartments(data.departmentList || []);
      setTotalCount(data.totalCount || 0);
      setIsFetching(false);
    } catch (error) {
      if (handleApiError(error)) return;

      console.log("Error while Fetching Department:", error);
    } finally {
      setIsFetching(false);
    }
  };
  const handleSearch = (event) => {
    const value = event.target.value;

    setSearchKey(value);
    setPage(1);
    if (/[<>]/.test(value)) {
      setSearchError(constatntMessages.titleRegexError);
    } else {
      setSearchError("");
    }
  };
  const fetchDepartmentData = async () => {
    const bodyData = searchKey
      ? { searchKey, organizationId }
      : { organizationId };

    await fetchDepartment(bodyData);
  };

  //Row per page
  const handleRowsPerPageChange = (e) => {
    setLimit(parseInt(e.target.value, 10));
    setPage(1);
  };
  //pagination
  const handlePageChange = (event, value) => {
    setPage(value);
  };
  const fromDataCount = departments.length === 0 ? 0 : (page - 1) * limit + 1;
  const toDataCount = (page - 1) * limit + departments.length;

  const totalPage = Math.ceil(totalCount / limit);
  const maxOption = Math.ceil(totalCount / 5) * 5;

  const handleClearSearch = () => {
    setSearchKey("");
    setPage(1);
    fetchDepartmentData();
  };
  //EDIT DEPARTMENT
  const editDepartmentnameValidationCheck = () => {
    const errors = {};
    if (!departmentName.trim()) {
      errors.departmentName = "Department is required";
    } else if (!excludeHtml.test(departmentName)) {
      errors.departmentName = constatntMessages.invalidInput;
    } else if (departmentName.length < 2 || departmentName.length > 100) {
      errors.departmentName = "Department must be between 2 - 100  characters";
    }
    setErrors(errors);
    return errors;
  };

  const editIsValid = () => {
    let isValid = true;
    const errors = {};

    if (!departmentName.trim()) {
      errors.departmentName = "Department is required";
      isValid = false;
    } else if (!excludeHtml.test(departmentName)) {
      errors.departmentName = constatntMessages.invalidInput;
      isValid = false;
    } else if (
      departmentName.trim().length < 2 ||
      departmentName.trim().length > 100
    ) {
      errors.departmentName = "Department must be between 2 - 100  characters";
      isValid = false;
    } else {
      delete errors.departmentName;
    }

    setErrors(errors);
    return errors;
  };

  const handleEditDepartment = async (e) => {
    const newErrors = editIsValid();

    setIsEditLoading(true);

    if (Object.keys(newErrors).length === 0) {
      try {
        if (!accessToken) {
          console.warn("Access token is missing");
          return;
        }
        setErrors({});

        const updatedDepartment = {
          name: departmentName.trim(),
          organizationId,
        };

        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/V1/department/editDepartment/${selectedDepartment._id}`,
          updatedDepartment,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: accessToken,
              ip: await fetchIpAddress(),
            },
          }
        );
        if (response?.data?.data?.isInValidUser) {
          dispatch(setInValidUser(true));
        } else {
          dispatch(setInValidUser(false));
        }
        if (response.data.success) {
          setEditFormValues({ name: "" });
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });

          setSelectedDepartment(null);
          setShowEditModal(false);
          fetchDepartmentData();
        } else {
          toast.error(response.data.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setShowEditModal(true);
        }

        setErrors({ ...errors, [editformValues.name]: "" });
      } catch (error) {
        if (handleApiError(error)) return;
       

        console.log("Error while updating Department:", error.message);
      } finally {
        setIsEditLoading(false);
      }
    } else {
      setIsEditLoading(false);
    }
  };

  const handleEditSaveClick = () => {
    const newErrors = editIsValid();
    if (Object.keys(newErrors).length === 0) {
      setIsConfirming(true);
    } else {
      setShowEditModal(true);
      setIsConfirming(false);
    }
  };

  const handleConfirmSave = () => {
    handleEditDepartment();
    setShowEditModal(false);
    setIsConfirming(false);
  };

  const handleCancel = () => {
    setIsConfirming(false);
  };

  //DELETE DEPARTMENT
  const handleDeleteClick = (department) => {
    setDepartmenToDelete(department);
    setShowDeleteModal(true);
  };
  const handleDeleteConfirm = async () => {
    try {
      if (departmentToDelete) {
        await deleteDepartment(departmentToDelete._id);
        setShowDeleteModal(false);
        setDepartmenToDelete(null);
      }
    } catch (error) {
      console.error("Error while deleting unit:", error);
    }
  };

  const deleteDepartment = async (departmentId) => {
    try {
      if (!accessToken) {
        console.warn("Access token is missing");
        return;
      }
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/api/V1/department/deleteDepartment/${departmentId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: accessToken,
            ip: await fetchIpAddress(),
          },
        }
      );
      if (response?.data?.data?.isInValidUser) {
        toast.error(response?.data?.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        dispatch(setInValidUser(true));
      } else {
        dispatch(setInValidUser(false));
      }
      if (response.data.success) {
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      const totalRemainingItems = totalCount - 1;
      const maxPages = Math.ceil(totalRemainingItems / limit);
      if (page > maxPages) {
        setPage(page - 1);
      }
      fetchDepartmentData();
      return response.data;
    } catch (error) {
      if (handleApiError(error)) return;

      console.error("Error deleting unit:", error);
      throw error;
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };

  return (
    <div>
      <div className="main-content">
        <div className="Action-list-page">
          <div className="meeting-header-text line-height-h4 d-flex align-items-center justify-content-between">
            <h4>Add Departments</h4>
            <div>
              <BackButton show={camefromPreviousPage} />
            </div>
          </div>
          <div className="mt-2 table-box responsive-table">
            <form className="meeting-form" onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-xl-4">
                  <div className="form-group">
                    <label className="mb-1">
                      Department Name<span className="star-mark"> *</span>
                    </label>
                    <input
                      type="text"
                      name="name"
                      autoComplete="off"
                      placeholder="Enter Department Name"
                      onChange={handleChange}
                      value={formValues.name}
                      onBlur={dpnameValidationCheck}
                    />
                    {errors.name && (
                      <span className="error-message">{errors.name}</span>
                    )}
                  </div>
                </div>
              </div>
              {isLoading ? (
                <SmallLoaderButton />
              ) : (
                <button
                  className="create-meeting-button Mom-btn"
                  disabled={isLoading}
                >
                  <p>Submit</p>
                </button>
              )}
            </form>
          </div>

          <div className="meeting-header-text line-height-h4 mt-4">
            <h4 className="mt-2">Manage Department(s)</h4>
          </div>
          <div className="mt-2 table-box responsive-table">
          <div className="d-flex align-items-center justify-content-between resp-flex-column mb-2">
            <div className="tbl-text-search  resp-unit-search w-100">
              <div className="left-tbl-text text-mb-3">
                {totalCount > 0 ? (
                  <p>
                    Showing {fromDataCount} to {toDataCount} of {totalCount}{" "}
                    department(s)
                  </p>
                ) : null}
              </div>
              <div>
                <div className="search-box position-relative unit-search">
                  <input
                    type="search"
                    autoComplete="off"
                    placeholder="Search By Department "
                    value={searchKey}
                    onChange={handleSearch}
                  />
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="#4F2CC8"
                    className="bi bi-search"
                    viewBox="0 0 16 16"
                  >
                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                  </svg>
                  {searchError && (
                    <span className="error-message">{searchError}</span>
                  )}
                </div>
              </div>
            </div>
            </div>
           

            {isFetching ? (
              <div className="d-flex align-items-center justify-content-between resp-flex-column mb-2">
              <div className="tbl-text-search resp-unit-search">
                <div className="meeting-page loader-cont">
                  <Loader />
                </div>
              </div>
              </div>
            ) : departments.length > 0 ? (
              <>
                <Table className="mt-4 table table-bordered table-striped unit-table">
                  <thead>
                    <tr>
                      <th className="text-align-center"   style={{ width: "50px" }}>Sl. No.</th>
                      <th>Department</th>

                      <th  className="text-align-center" >Updated At</th>

                      {window.innerWidth <= 768 ? null : (
                        <th scope="col" className="action-col">
                          Action
                        </th>
                      )}
                    </tr>
                  </thead>{" "}
                  <tbody>
                    {departments.map((department, index) => {
                      return (
                        <tr key={index}>
                          <td
                            data-label="Sl. No."
                            className="text-align-center blue-bold-text"
                              style={{ width: "50px" }}
                          >
                            {index + 1 + (page - 1) * limit}
                          </td>
                          <td data-label="Department" className="word-break">
                            {department.name}

                            {/* /// monalisa added here */}

                            {window.innerWidth <= 768 ? (
                              <div className="d-inline-block menu-dropdown custom-dropdown inner1-drp resp-innerdrp-1">
                                <Dropdown>
                                  <div className="dropdown-opt d-inline-block menu-dropdown custom-dropdown">
                                    <Dropdown.Toggle id="dropdown-basic">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="#000"
                                        className="bi bi-three-dots-vertical"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                                      </svg>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                      <Dropdown.Item
                                        onClick={() =>
                                          handleEditClick(department)
                                        }
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="20"
                                          fill="currentColor"
                                          className="me-2 bi bi-pencil-square"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                          <path
                                            fillRule="evenodd"
                                            d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                                          />
                                        </svg>
                                        Edit
                                      </Dropdown.Item>
                                      <hr className="dropdown-divider" role="separator" />
                                      <Dropdown.Item className="delete-drp"
                                        onClick={() =>
                                          handleDeleteClick(department)
                                        }
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="18"
                                          height="18"
                                          fill="currentColor"
                                          className="me-2 bi bi-trash3"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
                                        </svg>
                                        Delete
                                      </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </div>
                                </Dropdown>
                              </div>
                            ) : null}

                            {/* /// monalisa added here */}
                          </td>

                          <td data-label="Updated At"  className="text-align-center">
                            <p className="detail-date-time">
                              <span>{department.formattedDate}</span>                            
                              <span className="text-secondary fs-12">{department.formattedTime}</span>
                            </p>
                          </td>
                          {window.innerWidth <= 768 ? null : (
                            <td
                              data-label="Action"
                              className="meeting-td-width-7 text-align-center"
                            >
                              <Dropdown>
                                <div className="dropdown-opt d-inline-block menu-dropdown custom-dropdown">
                                  <Dropdown.Toggle id="dropdown-basic">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="#000"
                                      className="bi bi-three-dots-vertical"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                                    </svg>
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu>
                                    <Dropdown.Item
                                      onClick={() =>
                                        handleEditClick(department)
                                      }
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        fill="currentColor"
                                        className="me-2 bi bi-pencil-square"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                        <path
                                          fillRule="evenodd"
                                          d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                                        />
                                      </svg>
                                      Edit
                                    </Dropdown.Item>
                                    <hr className="dropdown-divider" role="separator" />
                                    <Dropdown.Item className="delete-drp"
                                      onClick={() =>
                                        handleDeleteClick(department)
                                      }
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="18"
                                        height="18"
                                        fill="currentColor"
                                        className="me-2 bi bi-trash3"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
                                      </svg>
                                      Delete
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </div>
                              </Dropdown>
                            </td>
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>

                <div className="tbl-bottom">
                  <div className="left-tbl-bottom">
                    {/* Left Arrow Button */}
                    {page !== 1 ? (
                      <button
                        className="left-arrow"
                        onClick={() => setPage(page > 1 ? page - 1 : 1)}
                        disabled={page === 1}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="#fff"
                          className="bi bi-chevron-left"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fillRule="evenodd"
                            d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
                          />
                        </svg>
                      </button>
                    ) : null}

                    {/* Pagination Component from MUI without arrows */}
                    <Stack spacing={2}>
                      <Pagination
                        count={totalPage}
                        page={page}
                        siblingCount={0}
                        boundaryCount={2}
                        onChange={handlePageChange}
                        hidePrevButton
                        hideNextButton
                        sx={{
                          "& .Mui-selected": {
                            backgroundColor: "#388d27 !important",
                            color: "#fff !important",
                          },
                        }}
                      />
                    </Stack>

                    {/* Right Arrow Button */}
                    {page < totalPage ? (
                      <button
                        className="right-arrow"
                        onClick={() =>
                          setPage(page * limit < totalCount ? page + 1 : page)
                        }
                        disabled={page * limit >= totalCount}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="#fff"
                          className="bi bi-chevron-right"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fillRule="evenodd"
                            d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
                          />
                        </svg>
                      </button>
                    ) : null}
                  </div>

                  {/* Rows Per Page Selector */}
                  <div className="right-tbl-bottom">
                    <p>Rows Per Page</p>
                    <select
                      className="no-opt-box"
                      name="limit"
                      onChange={handleRowsPerPageChange}
                      value={limit}
                    >
                      {Array.from({ length: maxOption / 5 }).map((_, index) => {
                        const value = (index + 1) * 5;
                        return (
                          <option key={value} value={value}>
                            {value}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </>
            ) : (
              <div className="no-data-img mt-3">
                <>
                  <Alert
                    status={"info"}
                    message={"No data available."}
                    timeoutSeconds={0}
                  />
                  <NoDataFound dataType={"meeting"} />
                  <div className="button-outer">
                    <Button variant="primary" onClick={handleClearSearch}>
                      Clear
                    </Button>
                  </div>
                </>
              </div>
            )}
          </div>
          <Modal
            show={showEditModal}
            onHide={() => setShowEditModal(false)}
            backdrop="static"
          >
            <Modal.Header closeButton>
              <Modal.Title>Edit Department</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {isConfirming ? (
                // Confirmation view
                <p>Are you sure you want to update this department?</p>
              ) : (
                // Edit form view
                <Form>
                  <Form.Group controlId="departmentName">
                    <Form.Label>
                      Department<span className="star-mark"> *</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Department"
                      value={departmentName}
                      autoComplete="off"
                      onKeyDown={handleKeyDown}
                      onChange={(e) => setDepartmentName(e.target.value)}
                      onBlur={editDepartmentnameValidationCheck}
                    />
                  </Form.Group>
                  {errors.departmentName && (
                    <span className="error-message">
                      {errors.departmentName}
                    </span>
                  )}
                </Form>
              )}
            </Modal.Body>
            <Modal.Footer>
              {isConfirming ? (
                <>
                  <Button
                    variant=""
                    className="add-minutes Mom-btn"
                    onClick={handleCancel}
                  >
                    <p>Cancel</p>
                  </Button>
                  <Button
                    variant=""
                    className="create-meeting-button Mom-btn "
                    onClick={handleConfirmSave}
                  >
                    <p>Confirm Update</p>
                  </Button>
                </>
              ) : (
                <Button
                  variant=""
                  className="create-meeting-button Mom-btn"
                  onClick={handleEditSaveClick}
                >
                  <p>Save Changes</p>
                </Button>
              )}
            </Modal.Footer>
          </Modal>

          <Modal
            show={showDeleteModal}
            onHide={() => setShowDeleteModal(false)}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Confirm Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Are you sure you want to delete this Department?
            </Modal.Body>
            <Modal.Footer>
              {isLoading ? (
                <SmallLoaderButton />
              ) : (
                <Button
                  variant=""
                  className="add-minutes Mom-btn"
                  onClick={handleDeleteConfirm}
                >
                  <p>Delete</p>
                </Button>
              )}
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </div>
  )
}

export default Department